import { useTranslation } from "react-i18next";
import { Posts as PostsFeature } from "@/partner/features/posts";
import { Meta } from "@/shared/components";

export function PostsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("posts.pageTitle")} pageType="Partner" />
      <PostsFeature />
    </>
  );
}
